import React from "react";
import { ICellRendererParams } from "ag-grid-community";
import { get } from "lodash";

/**
 * Shows the livestock sale name and saleyard name for grouped rows.
 * When not grouped, it just displays the sale name.
 */
export function LivestockSaleGroupRenderer(params: ICellRendererParams) {
  const { value, node, colDef } = params;

  const defaultDisplay = <span>{value || ""}</span>;

  // Early return for non-grouped rows or when this isn't the row group column
  if (!node?.group || !node.rowGroupColumn) {
    return defaultDisplay;
  }

  // Check if this is the row group column - try multiple ways to match
  const rowGroupColId = node.rowGroupColumn.getColId();
  const rowGroupField = node.rowGroupColumn.getColDef()?.field;
  const isRowGroupColumn =
    colDef?.colId === rowGroupColId ||
    colDef?.field === rowGroupField ||
    colDef?.field === "livestockSale.title" ||
    rowGroupField === "livestockSale.title";

  if (!isRowGroupColumn) {
    return defaultDisplay;
  }

  // Get saleyard name from first child (saleyard name should be consistent within a group)
  // The first child might be a group node, so check allLeafChildren if data is not available
  const firstChild = node.childrenAfterGroup?.[0];
  let saleyardName = null;
  if (firstChild?.data) {
    saleyardName = get(firstChild.data, "saleyardName");
  } else if (
    firstChild?.allLeafChildren &&
    firstChild.allLeafChildren.length > 0
  ) {
    saleyardName = get(firstChild.allLeafChildren[0].data, "saleyardName");
  }

  const saleName = value || "Unknown Sale";
  const displayText = saleyardName ? `${saleName} - ${saleyardName}` : saleName;

  return <span>{displayText}</span>;
}
